
export enum TableRowHeights {
	COMPACT = 24,
	COMFORTABLE = 32,
	DEFAULT = COMPACT
}


